import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/empresas/v2`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findEmpresasV2(empresa_cnpj, id) {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}

export async function updateEmpresasV2({ empresa_cnpj, id, body }) {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    { empresa: body }
  );
}

export async function findProgressoConfiguracoes(empresa_cnpj, idEmpresa) {
  const url = `${path}/progresso-configuracoes/${idEmpresa}?empresa_cnpj=${empresa_cnpj}`;
  return search(url, "GET", headers);
}
